import { render, staticRenderFns } from "./MrpDetailModal.vue?vue&type=template&id=f055a8f4&scoped=true"
import script from "./MrpDetailModal.vue?vue&type=script&lang=js"
export * from "./MrpDetailModal.vue?vue&type=script&lang=js"
import style0 from "./MrpDetailModal.vue?vue&type=style&index=0&id=f055a8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f055a8f4",
  null
  
)

export default component.exports